class SessionStorage {
  static getItem(key: string) {
    try {
      const serialized = sessionStorage.getItem(key);
      if (!serialized) {
        return serialized;
      }
      return JSON.parse(serialized);
    } catch (error) {
      return null;
    }
  }

  static setItem(key: string, value: any) {
    const serialized = JSON.stringify(value);
    sessionStorage.setItem(key, serialized);
  }

  static removeItem(key: string) {
    sessionStorage.removeItem(key);
  }
}

export default SessionStorage;
